import QuestionIcon from '@atlaskit/icon/glyph/question';
import Button from '@atlaskit/button';
import React from 'react';
import { colors } from '@atlaskit/theme';
import { SyntaxHelpContainer } from './styled';
export var BaseSyntaxHelp = function BaseSyntaxHelp(_ref) {
  var describedby = _ref.describedby,
      isDisabled = _ref.isDisabled,
      label = _ref.label,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(SyntaxHelpContainer, null, /*#__PURE__*/React.createElement(Button, {
    "aria-describedby": describedby,
    "aria-label": label,
    isDisabled: isDisabled,
    appearance: 'subtle',
    spacing: 'none',
    target: 'blank',
    href: "https://confluence.atlassian.com/display/SERVICEDESKCLOUD/Advanced+searching",
    iconBefore: /*#__PURE__*/React.createElement(QuestionIcon, {
      label: '',
      primaryColor: isDisabled ? "var(--ds-text-disabled, ".concat(colors.N0, ")") : "var(--ds-text-onBold, ".concat(colors.N0, ")"),
      size: 'small'
    }),
    onClick: onClick
  }));
};